import React from 'react'

import ComplaintsPage from './complaints-page'

export default function OurComplaints() {
    return <ComplaintsPage />
}
